import React, { useState, useCallback } from 'react';
import dashboardApi from 'services/apis/dashboard';
import { Col } from 'react-bootstrap';
import Toggle from 'v3/components/Toggle';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { BsFillPieChartFill } from 'react-icons/bs';
import { useModal } from 'hooks';
import api from 'services/api';
import CityModal from '../Modals/City';
import { StyledDescription } from './Card/styles';
import { DateOptions } from './Card/utils';
import Card, { Description, CityPieChart, CityMap } from './Card';

const TOGGLE_OPTIONS = [
  {
    label: <FaMapMarkedAlt />,
    value: true,
  },
  {
    label: <BsFillPieChartFill />,
    value: false,
  },
];

export default function DestinationsWithMoreRequests({ dashboard, name, id }) {
  const [data, setData] = useState([]);
  const [showMap, setShowMap] = useState(TOGGLE_OPTIONS[0].value);
  const modal = useModal();
  const [loading, setLoading] = useState(false);

  async function handleChangeDate(value, setSelectedDate, setValues, values) {
    setSelectedDate(value);
    setValues((old) => ({ ...old, date: value }));

    const payload = {
      tags: values.tags,
      clients: values.clients,
      sizes: values.size,
      component: name,
      date: value,
      card_id: id,
    };

    await api.put(`v3/dashboard/${dashboard.id}/parameters`, payload);
  }

  const fetchDestinationsWithMoreRequests = useCallback(async (filters = {}) => {
    try {
      setLoading(true);
      const { date } = filters;

      const response = await dashboardApi.get('destinations-with-more-requests', {
        params: {
          start_date: date.value.start_date,
          end_date: date.value.end_date,
        },
      });

      setData(response.data);
    } catch (error) {
      // adding a comment because will is gonna kill me if i dont
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <CityModal
        isOpen={modal.isOpen}
        onClose={modal.close}
        name={name}
        dashboard={dashboard}
        data={data}
      />
      <Card
        title="Destinos com maior demanda"
        isLoading={loading}
        fetchFn={fetchDestinationsWithMoreRequests}
        onFiltersChanged={fetchDestinationsWithMoreRequests}
        dashboard={dashboard}
        name={name}
        hideFilter
        id={id}
        dates={DateOptions.monthly}
        dateFilter
        handleChangeDate={handleChangeDate}
        excludeFilterByBranchOffice
        dateFilterOptionLabel={(option) => option.label}
        dateFilterOptionValue={(option) => option.value}
        NumericComponent={
          <>
            {showMap ? (
              <CityMap
                data={data}
                height={450}
                latKey="destination_latitude"
                lonKey="destination_longitude"
              />
            ) : (
              <CityPieChart data={data} valueKey="destination_value" cityKey="destination_city" />
            )}
            <StyledDescription>
              <Col xs={12} md={9}>
                <Description openModal modal={modal} clickable>
                  ver origens frequentes para estes destinos
                </Description>
              </Col>
              <Col xs={12} md={3} className="d-flex align-items-center justify-content">
                <Toggle
                  label=""
                  value={showMap}
                  defaultValue={showMap}
                  options={TOGGLE_OPTIONS}
                  onSelected={(value) => setShowMap(value)}
                />
              </Col>
            </StyledDescription>
          </>
        }
      />
    </>
  );
}
